import {
  PLAN_SEGMENT_FILTER,
  PLAN_TYPE_FILTER,
  RULES_FILTER,
  PLAN_STRATEGY_FILTER,
} from "../../../pricingv2/pricingLifecycleFilters";
import {
  AD_SOURCE_FILTER,
  AD_STATUS_FILTER,
  AD_TYPE_FILTER,
  NTM_STATUS_FILTER,
  SCHEDULED_BUDGET_CHANGES_FILTER,
} from "../../../advertising/filters/adLifecycleFilters";
import { ORG_CHANNEL_FILTER, ORG_TYPE_FILTER } from "../../../advertising/filters/orgLifecycleFilters";
import {
  INVENTORY_STATE_FILTER,
  PRICING_PRODUCT_ENROLMENT_FILTER,
  PRODUCT_AD_STATUS_FILTER,
  PRODUCT_WITH_ADS_FILTER,
  SALES_STATE_FILTER,
} from "../../../advertising/filters/productLifecycleFilters";
import { PROMOTION_STATUS_FILTER, PROMOTION_TYPE_FILTER } from "../../../advertising/filters/promotionReportFilters";
import {
  BID_PREVIEW_WARNING_FILTER,
  KEYWORD_MATCH_TYPE_FILTER,
  SEARCH_TERM_REPORT_MATCH_TYPE_FILTER,
  TARGET_MATCH_TYPE_FILTER,
  TARGET_STATE_FILTER,
} from "../../../advertising/filters/targetLifecycleFilters";
import { AMC_REPORT_TYPE_FILTER, AUDIENCE_STATUS_FILTER } from "../../../amc/components/audience/lifecycleFilters";
import {
  DSP_ORDER_STATE_FILTER,
  DSP_ORDER_STATUS_FILTER,
  DSP_PRODUCT_CONVERSION_TYPE_FILTER,
} from "../../../dsp/utils/dspLifecycleFilters";

export const LIFECYCLE_FILTER_OPTIONS = [
  // Ad filter options
  AD_TYPE_FILTER,
  AD_STATUS_FILTER,
  NTM_STATUS_FILTER,
  AD_STATUS_FILTER,
  AD_SOURCE_FILTER,
  SCHEDULED_BUDGET_CHANGES_FILTER,
  // Target/keyword filter options
  BID_PREVIEW_WARNING_FILTER,
  KEYWORD_MATCH_TYPE_FILTER,
  SEARCH_TERM_REPORT_MATCH_TYPE_FILTER,
  TARGET_MATCH_TYPE_FILTER,
  TARGET_STATE_FILTER,
  // Product filter options
  INVENTORY_STATE_FILTER,
  SALES_STATE_FILTER,
  PRODUCT_WITH_ADS_FILTER,
  PRODUCT_AD_STATUS_FILTER,
  PRICING_PRODUCT_ENROLMENT_FILTER,
  // Org filter options
  ORG_CHANNEL_FILTER,
  ORG_TYPE_FILTER,
  // Promo report filter options
  PROMOTION_TYPE_FILTER,
  PROMOTION_STATUS_FILTER,
  // Pricing plan filter options
  PLAN_SEGMENT_FILTER,
  RULES_FILTER,
  PLAN_TYPE_FILTER,
  PLAN_STRATEGY_FILTER,
  // DSP dashboard filter options
  DSP_ORDER_STATUS_FILTER,
  DSP_ORDER_STATE_FILTER,
  DSP_PRODUCT_CONVERSION_TYPE_FILTER,
  // AMC audience filters
  AUDIENCE_STATUS_FILTER,
  // AMC report filters
  AMC_REPORT_TYPE_FILTER,
];

// Below dynamic filters can't be saved as they rely on dynamic input beyond just a given tableId
export const FILTER_IDS_BLACKLIST = [
  "bidding_program_name",
  "variants",
  "market_place",
  "target_source",
  "bid_type",
  "agencies",
  "tags",
  "product_category",
  "audience_asins",
  "template_display_name",
  "audience_template_tags",
];

export const PERCENT_COLUMNS_NOT_IN_DECIMAL_FORMAT = ["max_acos", "target_acos"];
